import React, { useState } from 'react';
import axios from 'axios';
import { Modal, List, Typography, Table, Space, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Search } = Input;

const TennisPlayerSearch = () => {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const searchPlayers = async (name) => {
    if (!name) return;
    
    setLoading(true);
    try {
      const response = await axios.get(`https://asia-northeast3-nawaplay-6dadb.cloudfunctions.net/api/tennis/player/ranking/search?name=${encodeURIComponent(name)}`);
      if (response.data.success) {
        setPlayers(response.data.data);
      }
    } catch (error) {
      console.error('선수 검색 중 오류 발생:', error);
    } finally {
      setLoading(false);
    }
  };

  const showPlayerDetails = (player) => {
    setSelectedPlayer(player);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedPlayer(null);
  };

  const columns = [
    {
      title: '대회명',
      dataIndex: 'tournament',
      key: 'tournament',
    },
    {
      title: '날짜',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: '포인트',
      dataIndex: 'points',
      key: 'points',
      render: (points) => points || '-',
    },
    {
      title: '순위',
      dataIndex: 'result',
      key: 'result',
    },
  ];

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Title level={2}>테니스 선수 랭킹 검색</Title>
      
      <Search
        placeholder="선수 이름을 입력하세요"
        allowClear
        enterButton={<SearchOutlined />}
        size="large"
        onSearch={searchPlayers}
        style={{ marginBottom: '24px', maxWidth: '500px' }}
      />

      <List
        loading={loading}
        dataSource={players}
        renderItem={(player) => (
          <List.Item
            onClick={() => showPlayerDetails(player)}
            style={{ cursor: 'pointer' }}
          >
            <List.Item.Meta
              title={`${player.organization}-${player.name} (${player.club})`}
              description={
                <Space>
                  {player.totalPoints && <Text>총 포인트: {player.totalPoints}</Text>}
                  <Text type="secondary">클릭하여 상세 정보 보기</Text>
                </Space>
              }
            />
          </List.Item>
        )}
      />

      <Modal
        title={`${selectedPlayer?.organization}-${selectedPlayer?.name} (${selectedPlayer?.club})`}
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={800}
      >
        {selectedPlayer?.records && selectedPlayer.records.length > 0 ? (
          <Table
            columns={columns}
            dataSource={selectedPlayer.records}
            rowKey={(record) => `${record.tournament}-${record.date}`}
            pagination={false}
          />
        ) : (
          <Text>대회 기록이 없습니다.</Text>
        )}
      </Modal>
    </div>
  );
};

export default TennisPlayerSearch; 